import { createContext } from "react";

const MND = ["jan", "feb", "mrt", "apr", "mei", "jun", "jul", "aug", "sep", "okt", "nov", "dec"];
const nul = (n) => String(n).padStart(2, "0");

export const fmtReactieTijd = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return "";
  return `${d.getDate()} ${MND[d.getMonth()]} ${nul(d.getHours())}:${nul(d.getMinutes())}`;
};

export const SnippetContext = createContext({});

// Zoeken negeert hoofdletters, regeleinden en dubbele spaties (in zoekterm én tekst).
export const norm = (t) => String(t || "").toLowerCase().replace(/\s+/g, " ").trim();

export const heeftBesluit = (a) => (a.reacties || []).some((r) => r.besluit);

export const reactieTreft = (a, q) => (a.reacties || []).find((r) => norm(r.tekst).includes(q));

export const reactieSnippet = (tekst, q) => {
  const plat = String(tekst || "").replace(/\s+/g, " ").trim();
  const i = Math.max(0, plat.toLowerCase().indexOf(q));
  const van = Math.max(0, Math.min(i - 30, plat.length - 90));
  const stuk = plat.slice(Math.max(0, van), Math.max(0, van) + 90);
  return `${van > 0 ? "…" : ""}${stuk}${van + 90 < plat.length ? "…" : ""}`;
};

const PREFIX = "tw1_reactie_";
export const wisReactieConcepten = () => {
  try {
    Object.keys(sessionStorage).filter((k) => k.startsWith(PREFIX)).forEach((k) => sessionStorage.removeItem(k));
  } catch { /* ignore */ }
};
export const leesConcept = (key) => {
  try { return JSON.parse(sessionStorage.getItem(PREFIX + key)) || null; } catch { return null; }
};
export const bewaarConcept = (key, waarde) => {
  try {
    if (waarde && (waarde.tekst || "").length > 0) sessionStorage.setItem(PREFIX + key, JSON.stringify(waarde));
    else sessionStorage.removeItem(PREFIX + key);
  } catch { /* ignore */ }
};
export const zoekEditConcept = (me, aid) => {
  try {
    const p = `${PREFIX}edit|${me}|${aid}|`;
    const k = Object.keys(sessionStorage).find((x) => x.startsWith(p));
    return k ? { id: k.slice(p.length), ...JSON.parse(sessionStorage.getItem(k)) } : null;
  } catch { return null; }
};
